/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * Categories of playback errors.
 * Used to classify errors for appropriate handling and display.
 */
export enum PlaybackErrorType {
  /**
   * General/unclassified error.
   */
  GENERAL_ERROR = 0,

  /**
   * Error related to location/geo restrictions.
   */
  LOCATION_ERROR = 1,

  /**
   * Error during video playback (player/stream issues).
   */
  PLAYBACK_ERROR = 2,

  /**
   * Error with the streaming session (create/keep-alive failures).
   */
  SESSION_ERROR = 3
}
